// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.search-wrapper {
  padding: 1.5rem;
  cursor: pointer;
  background: none;
  border: none;
}
.search-wrapper svg {
  margin-top: 0.1em;
  height: 1.9em;
}
.search-wrapper svg g path.cls-1 {
  fill: #4d4d4d;
}
.search-wrapper:hover svg {
  height: 2em;
}
.search-wrapper:hover svg g path.cls-1 {
  fill: #dabc64;
}
.search-wrapper:focus {
  outline: revert;
}

.search-text-wrapper {
  padding-top: 1.5rem;
  padding-left: 1.5rem;
  width: 30rem;
  max-width: 100vw;
  position: relative;
}
.search-text-wrapper .clear-btn {
  position: absolute;
  right: 0.5rem;
  top: 2rem;
  cursor: pointer;
  color: #696969;
  background: none;
  border: none;
  padding: 0;
  text-decoration: none;
}
.search-text-wrapper .clear-btn:hover, .search-text-wrapper .clear-btn:active, .search-text-wrapper .clear-btn:visited {
  text-decoration: none;
}
.search-text-wrapper .search-results {
  position: absolute;
  top: 5rem;
  left: 1.5rem;
  right: 0;
  max-height: 50rem;
  background: white;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
  border-radius: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 5000;
}
@media (max-width: 768px) {
  .search-text-wrapper .search-results {
    max-height: calc(100vh - 13rem);
  }
}
.search-text-wrapper .search-results .no-results {
  text-align: center;
  padding: 0.5rem;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/ApplicationNavigation/Search/Search.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAEF;AAAE;EACE,iBAAA;EACA,aAAA;AAEJ;AAAI;EACE,aAAA;AAEN;AAGI;EACE,WAAA;AADN;AAGM;EACE,aDLD;ACIP;AAME;EACE,eAAA;AAJJ;;AAQA;EACE,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AALF;AAOE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,cD1CY;EC2CZ,gBAAA;EACA,YAAA;EACA,UAAA;EAEA,qBAAA;AANJ;AAOI;EAGE,qBAAA;AAPN;AAWE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,gFAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AATJ;AAWI;EAbF;IAcI,+BAAA;EARJ;AACF;AAUI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AARN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.search-wrapper {\n  padding: 1.5rem;\n  cursor: pointer;\n  background: none;\n  border: none;\n\n  svg {\n    margin-top: 0.1em;\n    height: 1.9em;\n\n    g path.cls-1 {\n      fill: #4d4d4d;\n    }\n  }\n\n  &:hover {\n    svg {\n      height: 2em;\n\n      g path.cls-1 {\n        fill: $gold;\n      }\n    }\n  }\n\n  &:focus {\n    outline: revert;\n  }\n}\n\n.search-text-wrapper {\n  padding-top: 1.5rem;\n  padding-left: 1.5rem;\n  width: 30rem;\n  max-width: 100vw;\n  position: relative;\n\n  .clear-btn {\n    position: absolute;\n    right: 0.5rem;\n    top: 2rem;\n    cursor: pointer;\n    color: $darkTextColor;\n    background: none;\n    border: none;\n    padding: 0;\n\n    text-decoration: none;\n    &:hover,\n    &:active,\n    &:visited {\n      text-decoration: none;\n    }\n  }\n\n  .search-results {\n    position: absolute;\n    top: 5rem;\n    left: 1.5rem;\n    right: 0;\n    max-height: 50rem;\n    background: white;\n    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n    border-radius: 0.5rem;\n    overflow-x: hidden;\n    overflow-y: auto;\n    z-index: 5000;\n\n    @media (max-width: $tablet) {\n      max-height: calc(100vh - 13rem);\n    }\n\n    .no-results {\n      text-align: center;\n      padding: 0.5rem;\n      font-style: italic;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
